import { Outlet } from "react-router-dom";
import { Box, Container } from "@mui/material";

export default function DriverLayout() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "background.default",
        py: 2,
      }}
    >
      <Container maxWidth="sm" sx={{ px: 2 }}>
        <Outlet />
      </Container>
    </Box>
  );
}
